import 'css-chunksrc/client/scenes/calendar/week/task/styles.scss';export default {
  "task": "_task_107q5_1",
  "background": "_background_107q5_8",
  "main": "_main_107q5_17",
  "taskCompletionStatus": "_taskCompletionStatus_107q5_27",
  "progress": "_progress_107q5_34",
  "name": "_name_107q5_42",
  "icon": "_icon_107q5_51",
  "taskIcon": "_taskIcon_107q5_61"
};